import { useRef } from "react";
import "./App.css";
import HeroSection from "./components/HeroSection";
import EmailCapture from "./components/EmailCapture";
import HowItWorks from "./components/HowItWorks";
import SocialProofTicker from "./components/SocialProofTicker";
import Footer from "./components/Footer";

function App() {
  const emailRef = useRef(null);

  const scrollToEmail = () => {
    emailRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="bg-[#0D0D11] min-h-screen text-[#F0F0EE] overflow-x-hidden">
      {/* Top-left logo */}
      <div className="fixed top-4 left-5 z-50">
        <img
          src="https://customer-assets.emergentagent.com/job_restaurant-radar-8/artifacts/o5cdz2z8_ZnipdOrangePurple.png"
          alt="Znipd"
          className="h-10 w-auto object-contain"
        />
      </div>
      <HeroSection onGetEarlyAccess={scrollToEmail} />
      <SocialProofTicker />
      <div ref={emailRef}>
        <EmailCapture />
      </div>
      <HowItWorks />
      <Footer />
    </div>
  );
}

export default App;
